module.exports = __webpack_public_path__ + "img/weihua.f1de6a86.png";